import styled from 'styled-components';
import { theme } from '_constants/theme';
import { config } from '_config';
import * as React from 'react';
const { colors, devices, fontSizes, spaces } = theme;

const StyledWhyChooseMonitoringSection = styled.div`
  padding-top: 100px;
  padding-bottom: 100px;
  background: #fafaff;
  @media ${devices.tablet} {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;
const StyledContainer = styled.div`
  max-width: 1400px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  gap: 50px;
  @media ${devices.tablet} {
    flex-direction: column;
    gap: 10px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

const StyledLeftPart = styled.div`
  display: flex;
  flex-direction: column;
  color: #7b848d;
  font-size: 14px;
  font-family: 'MontserratRegular';
  line-height: 26px;
`;
const StyledLeftContainerColumn = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: row;
  align-items: center;
  gap: 30px;
  p {
    color: #7b848d;
    width: 100%;
    font-family: 'MontserratRegular';
    font-style: normal;
    font-size: ${fontSizes.small}px;
    line-height: 20px;
    text-align: left;
  }
  img {
    min-width: 200px;
  }
  @media ${devices.tablet} {
    flex-direction: column;
  }
`;
const StyledRightContainerColumn = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  p {
    color: #7b848d;
    width: 100%;
    font-family: 'MontserratRegular';
    font-style: normal;
    font-size: ${fontSizes.small}px;
    line-height: 20px;
    text-align: left;
  }
  img {
    max-width: 200px;
  }
`;
const StyledSeparator = styled.div`
  background: #dee0e8;
  width: 1px;
`;
const StyledHeader = styled.div`
  color: #f37217;
  font-family: 'MontserratBold';
  font-style: normal;
  font-size: ${fontSizes.regular}px;
  width: 100%;
  margin-bottom: 0.5rem;
  @media ${devices.tablet} {
    margin-bottom: 0px;
  }
`;
const StyledHeaderBlue = styled.div`
  color: #f37217;
  font-family: 'MontserratBold';
  font-style: normal;
  font-size: ${fontSizes.large4X}px;
  width: 100%;
  margin-bottom: 0.5rem;
  line-height: 30px;
  @media ${devices.tablet} {
    margin-bottom: 0px;
    font-size: ${fontSizes.largeX}px;
  }
`;
const WhyChooseMonitoringSection = () => {
  return (
    <StyledWhyChooseMonitoringSection>
      <StyledContainer>
        <StyledLeftContainerColumn>
          <img src={`${config.basePath}/protect-3.png`} alt="" layout="fill" />
          <StyledLeftPart>
            <StyledHeaderBlue>Why Choose Trademark Genius?</StyledHeaderBlue>{' '}
            Choosing Trademark Genius for your trademark-monitoring needs is a
            strategic decision. With years of experience and a proven track
            record, we are the go-to partner for businesses of all sizes. Our
            dedication to our clients and our expertise in the field set us
            apart.
          </StyledLeftPart>
        </StyledLeftContainerColumn>
        <StyledSeparator />
        <StyledLeftContainerColumn>
          <img src={`${config.basePath}/protect-1.png`} alt="" layout="fill" />
          <StyledLeftPart>
            <StyledHeaderBlue>
              The Importance of Trademark Monitoring
            </StyledHeaderBlue>{' '}
            The significance of trademark monitoring cannot be overstated.
            Without it, businesses are susceptible to brand dilution,
            counterfeiting, and loss of exclusivity. Trademark monitoring serves
            as the first line of defense against these threats.
          </StyledLeftPart>
        </StyledLeftContainerColumn>
      </StyledContainer>
    </StyledWhyChooseMonitoringSection>
  );
};

export default WhyChooseMonitoringSection;
